export const TRACK_EVENTS = {
  RATE_PLAN: {
    LIST_VIEWED: "payfac:rate_plan:list_viewed",
    FORM_VIEWED: "payfac:rate_plan:form_viewed",
    SHOW_VIEWED: "payfac:rate_plan:show_viewed",
    TAB_CHANGED: "payfac:rate_plan:tab_changed",
    SELLER_EDIT_CLICKED: "payfac:rate_plan:seller_edit_clicked",
    PIX_CLICKED: "payfac:rate_plan:pix_clicked",
    DEBIT_CLICKED: "payfac:rate_plan:debit_clicked",
    CREDIT_CLICKED: "payfac:rate_plan:credit_clicked",
    BOLETO_CLICKED: "payfac:rate_plan:boleto_clicked",
    RECEIPT_TYPE_CHANGE_CLICKED: "payfac:rate_plan:receipt_type_change_clicked",
    RECEIPT_TYPE_CONFIRM_CLICKED:
      "payfac:rate_plan:receipt_type_confirm_clicked",
    DELAY_FOR_REDEEM_ON_CHANGE: "payfac:rate_plan:delay_for_redeem_on_change",
    DELAY_FOR_REDEEM_CONFIRM_CLICKED:
      "payfac:rate_plan:delay_for_redeem_confirm_clicked",
    DELAY_FOR_REDEEM_CANCEL_CLICKED:
      "payfac:rate_plan:delay_for_redeem_cancel_clicked",
    CREATED_INTENT: "payfac:rate_plan:created_intent",
    CREATED_SUCCESS: "payfac:rate_plan:created_success",
    CREATED_ERROR: "payfac:rate_plan:created_error",
    UPDATED_INTENT: "payfac:rate_plan:updated_intent",
    UPDATED_SUCCESS: "payfac:rate_plan:updated_success",
    UPDATED_ERROR: "payfac:rate_plan:updated_error",
    HISTORY_VIEWED: "payfac:rate_plan:history_viewed",
    HISTORY_DETAIL_CLICKED: "payfac:rate_plan:history_detail_clicked",
    HISTORY_DETAIL_VIEWED: "payfac:rate_plan:history_detail_viewed",
  },
  RATES: {
    VIEWED: "payfac:rates:viewed",
    PIX_EDITED: "payfac:rates:pix_edited",
    BOLETO_EDITED: "payfac:rates:boleto_edited",
    DEBIT_EDITED: "payfac:rates:debit_edited",
    CREDIT_EDITED: "payfac:rates:credit_edited",
    UPDATED_INTENT: "payfac:rates:updated_intent",
    UPDATED_SUCCESS: "payfac:rates:updated_success",
    UPDATED_ERROR: "payfac:rates:updated_error",
    IMPORTED_INTENT: "payfac:rates:imported_intent",
    IMPORTED_SUCCESS: "payfac:rates:imported_success",
    IMPORTED_ERROR: "payfac:rates:imported_error",
  },
  REPORTS: {
    VIEWED: "payfac:reports:viewed",
    GENERATED_INTENT: "payfac:reports:generated_intent",
    GENERATED_SUCCESS: "payfac:reports:generated_success",
    GENERATED_ERROR: "payfac:reports:generated_error",
  },
  TRANSACTIONS: {
    VIEWED: "payfac:transactions:viewed",
    LOADED: "payfac:transactions:loaded",
    LOAD_ERROR: "payfac:transactions:load_error",
  },
  INDICATORS: {
    VIEWED: "payfac:indicators:viewed",
    LOADED: "payfac:indicators:loaded",
    LOAD_ERROR: "payfac:indicators:load_error",
  },
  TERMINALS: {
    VIEWED: "payfac:terminals:viewed",
    LOADED: "payfac:terminals:loaded",
    LOAD_ERROR: "payfac:terminals:load_error",
  },
  COMMISSIONS: {
    VIEWED: "payfac:commissions:viewed",
    LOADED: "payfac:commissions:loaded",
    LOAD_ERROR: "payfac:commissions:load_error",
  },
  SELLERS: {
    LIST_VIEWED: "payfac:sellers:list_viewed",
    LIST_SEARCHED: "payfac:sellers:list_searched",
    LIST_SORTED: "payfac:sellers:list_sorted",
    LIST_PAGE_CHANGED: "payfac:sellers:list_page_changed",
    LIST_PAGE_SIZE_CHANGED: "payfac:sellers:list_page_size_changed",
    ROW_CLICKED: "payfac:sellers:row_clicked",
    NEW_CLICKED: "payfac:sellers:new_clicked",
    COMPLETE_REGISTRATION_CLICKED:
      "payfac:sellers:complete_registration_clicked",
  },
  PENDENCIES: {
    LIST_VIEWED: "payfac:pendencies:list_viewed",
    SHOW_VIEWED: "payfac:pendencies:show_viewed",
    SHOW_CLICK_NAVIGATE_PLAN: "payfac:pendencies:show_click_navigate_plan",
    CONSENT_SELECTED: "payfac:pendencies:consent_selected",
    SUBMIT_INTENT: "payfac:pendencies:submit_intent",
    SUBMIT_SUCCESS: "payfac:pendencies:submit_success",
    SUBMIT_ERROR: "payfac:pendencies:submit_error",
    TOGGLE_RESOLVED: "payfac:pendencies:toggle_resolved",
    CAROUSEL_SWIPE: "payfac:pendencies:carousel_swipe",
    CAROUSEL_SUBMIT: "payfac:pendencies:carousel_submit",
  },
} as const;
